// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import "./styles/index.css";
import AuthProvider from "./context/AuthProvider";
import { detectSourceFromHostname, applyBrandToDOM } from "./utils/branding";

const detectedSource = detectSourceFromHostname(window.location.hostname);
applyBrandToDOM(detectedSource);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);
